import { render, staticRenderFns } from "./AddMediaToTest.vue?vue&type=template&id=4da93543&scoped=true&"
import script from "./AddMediaToTest.vue?vue&type=script&lang=js&"
export * from "./AddMediaToTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da93543",
  null
  
)

export default component.exports